<template>
    <div>
        <Banner :banners="banners" show-overlay class="white"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper green contentCenter">
            <h2 class="title text-center title-align">減碳計算機</h2>
            <p class="carbon-text-sm">
                在生活中，一舉一動都容易產生碳排放，但你知道簡單的改變一些生活習慣，就能有效減少碳排放嗎？<br>這些改變看似微小，但如果大家都響應並且實踐，將對減緩氣候變化產生重大影響唷！<br>快來看看你能做些什麼吧~
            </p>
            <a @click="goView('/carbon/calculator/' + item.url)" class="itemStyle" v-for="(item, index) in itemList"
                :key="index">
                <div class="imgBox">
                    <img :src="item.imgUrl" alt="icon">
                </div>
                <p>{{ item.title }}</p>
            </a>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
            itemList: [
                {
                    title: '食',
                    imgUrl: require('@/assets/calculator/001-diet.svg'),
                    url: 'food',
                },
                {
                    title: '衣',
                    imgUrl: require('@/assets/calculator/002-clothes.svg'),
                    url: 'cloth',
                },
                {
                    title: '住',
                    imgUrl: require('@/assets/calculator/003-house.svg'),
                    url: 'living',
                },
                {
                    title: '行',
                    imgUrl: require('@/assets/calculator/004-vehicles.svg'),
                    url: 'Steps',
                },
            ],
        };
    },
    components: {
        Banner,
        Breadcrumb,
    },
    methods: {
        goView(link) {
            this.$router.push(link).catch(() => { });
        },
    },
    mixins: [coreMixin],
};
</script>

<style scoped>
.itemStyle {
    width: 85%;
    border-top: 9px #D7B496 solid;
    background-color: #FFFAEE;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    color: rgb(170, 170, 170);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.imgBox {
    margin: 8px 0;
    width: 48px;
    height: 48px;
}

.imgBox>img {
    width: 100%;
    height: 100%;
}
</style>
